var _g, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRedLock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9,
    r: 9,
    fill: "#FF2626"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 11,
    cy: 9,
    r: 8.5,
    stroke: "#FD6E6E"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2 7.05263H11.0239H10.7942H8.61818V6.00429C8.61818 4.8489 9.6464 3.89474 10.9094 3.89474C12.1718 3.89474 13.2 4.8489 13.2 6.00429V7.05263ZM11.6139 10.6894V12.3806C11.6139 12.5727 11.4631 12.7368 11.2822 12.7368H10.5365C10.3551 12.7368 10.2048 12.5727 10.2048 12.3806V10.6894C10.029 10.5061 9.92727 10.2495 9.92727 9.96768C9.92727 9.43147 10.3132 8.97021 10.8053 8.94942C10.857 8.94668 10.9612 8.94668 11.0134 8.94942C11.505 8.97021 11.8909 9.43147 11.8909 9.96768C11.8909 10.2495 11.7892 10.5061 11.6139 10.6894ZM15.1223 6.84552H14.8722V5.7514C14.8722 3.72806 13.1635 2.03612 11.0255 2.00121C10.9672 1.9996 10.8504 1.9996 10.7926 2.00121C8.65469 2.03612 6.94537 3.72806 6.94537 5.7514V6.84552H6.69586C6.31188 6.84552 6 7.21775 6 7.67752V13.1664C6 13.6251 6.31188 14 6.69586 14H15.1223C15.5063 14 15.8182 13.6251 15.8182 13.1664V7.67752C15.8182 7.21775 15.5063 6.84552 15.1223 6.84552Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 0,
    y: 0,
    width: 22,
    height: 22,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0509804 0 0 0 0 0.113725 0 0 0 0 0.196078 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "multiply",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedLock);
export default __webpack_public_path__ + "static/media/red-lock.e68d14b478e4b9638538e646976825f5.svg";
export { ForwardRef as ReactComponent };